declare const __APP_VERSION__: string;

const DEFAULT_PROD_API = "https://be.pbranks.com/";

/** Base URL for API calls, always with a trailing slash. */
export function apiBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_URL as string | undefined;
  // In dev the Vite proxy serves `/api/`; a Capacitor or production build must
  // hit the absolute origin.
  const fallback = import.meta.env.DEV ? "/api/" : DEFAULT_PROD_API;
  return (fromEnv || fallback).replace(/\/*$/, "/");
}

export function imagesBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_IMAGES_URL as string | undefined;
  return (fromEnv || "https://images.pbranks.com/").replace(/\/*$/, "/");
}

/**
 * Mapbox public token for the interactive map, or "" when unconfigured.
 *
 * There is deliberately no hardcoded fallback. One used to live here — a token
 * inherited from the Quasar app — and it was silently revoked, so every map
 * rendered as a blank panel with no way to tell configuration from breakage
 * (#258). Callers must treat "" as "no interactive map" and fall back to the
 * server-rendered static route image.
 */
export function mapboxToken(): string {
  return (import.meta.env.VITE_MAPBOX_TOKEN as string | undefined) || "";
}

export function turnstileSiteKey(): string {
  return (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) || "";
}

/**
 * Public half of the server's VAPID key pair for browser push (#385), or ""
 * when unconfigured, in which case the web app offers no notifications toggle.
 * Must match VAPID_PUBLIC_KEY on pbranks_post.
 */
export function vapidPublicKey(): string {
  return (import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined) || "";
}

export const APP_VERSION = typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "dev";
// Overridden per environment (staging builds set it in .env.staging) so share
// links point at the environment that generated them.
export const SHARE_ORIGIN =
  (import.meta.env.VITE_SHARE_ORIGIN as string | undefined) || "https://run.pbranks.com";
